{
  "ro-RO": {
    "model": {
      "profile": {
        "id": "ID-ul utilizatorului.",
        "userName": "Nume de utilizator",
        "email": "Adresa de e-mail",
        "emailConfirmed": "Adresa de e-mail confirmată.",
        "phoneNumber": "Număr de telefon",
        "phoneNumberConfirmed": "Numărul de telefon a fost confirmat.",
        "twoFactorEnabled": "Autentificarea în doi factori este activată.",
        "lockoutEnd": "Data de încheiere a blocării",
        "lockoutEnabled": "Blocare activată.",
        "accessFailedCount": "Numărul de încercări de acces nereușite.",
        "firstName": "Prenume",
        "lastName": "Nume de familie",
        "picture": "Imagine pentru profil",
        "organisationName": "Organizație",
        "name": "Nume",
        "roles": "Roluri"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Confirmat"
      },
      "action": {
        "resetPassword.tooltip": "Trimiteți instrucțiunile de resetare a parolei utilizatorului prin e-mail."
      },
      "message": {
        "resetPassword.success": "Un e-mail a fost trimis utilizatorului cu instrucțiuni privind resetarea parolei."
      }
    }
  }
}